import { queryAll, query, fromId } from '../utils/utils.js';

export class ProviderDetailsPage {

    constructor() {
        
    }

}
